import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountOrderStatus';

const AccountOrderStatusSuspense = dynamic(
	() => import('./AccountOrderStatus'),
	{ loading: () => <BlockLoadingSpinner /> },
);

export default function DynamicAccountOrderStatus(props: Props) {
	return <AccountOrderStatusSuspense {...props} />;
}
DynamicAccountOrderStatus.displayName = 'DynamicAccountOrderStatus';
